import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import UpdateItem from "./update-item";
import Button from "./button";

import * as styles from "../styles/components/fc-updates.module.css";

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface Slug {
  current?: string;
}

interface LpSettings {
  image?: ImageAsset;
}

interface Category {
  title?: string;
  slug?: Slug;
}

interface Update {
  title?: string;
  slug?: Slug;
  category?: Category;
  lp?: LpSettings;
}

interface UpdateItem {
  _key?: string;
  update?: Update;
}

interface UpdatesProps {
  updates?: UpdateItem[];
  title?: string;
  theme?: string;
}

const Updates: React.FC<UpdatesProps> = ({
  updates,
  title,
  theme
}) => {
  if (!updates || updates.length === 0) {
    return null;
  }

  return (
    <div className={cn(styles.root, styles[theme])}>
      <Container>
        <div className={styles.text}>
          <h2 className={cn("h3", styles.title)}>{title || "Latest Updates"}</h2>
          <Button text="View All" url="/updates/" theme={theme} />
        </div>

        <div className="grid">
          {updates.map(({ _key, update }) => (
            <UpdateItem update={update} theme={theme} key={_key} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Updates;
